export default __webpack_public_path__ + "static/media/right-line.a8b438f3.svg";